export const getConnectionDeleteBlockReason = (connections = [], connection) => {
    const connectionCount = Array.isArray(connections) ? connections.length : 0;

    if (connectionCount <= 1) {
        return "You need at least one other connection before deleting this one.";
    }

    if (connection?.is_primary === true) {
        return "Set another connection as primary before deleting this one.";
    }

    return null;
};
